// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

i18n
  .use(Backend) // Load translations from server (or a local file)
  .use(initReactI18next) // Pass the i18n instance to react-i18next
  .init({
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    backend: {
      // Load translations from /public/locales/{lng}/{ns}.json
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
